<div class="{{styleClass}}">
    <input class="quick-filter" id="float-input" pInputText minlength="3" placeholder="Quick Filter" [(ngModel)]="quickFilterText"
        #filterTextLocal="ngModel" pTooltip="Filters for given text in data point description, name or units"
        showDelay="1000" hideDelay="500">
    <p-message class="cbms-margin-left" severity="error" text="At least 3 characters required"
        *ngIf="filterTextLocal.invalid && (filterTextLocal.dirty || filterTextLocal.touched)">
    </p-message>
</div>